"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logError = logError;

/** Log error to console and forward to NewRelic browser agent when available. */
function logError(error) {
  var _window$newrelic;

  console.error(error);

  if (typeof window !== 'undefined' && typeof ((_window$newrelic = window.newrelic) === null || _window$newrelic === void 0 ? void 0 : _window$newrelic.noticeError) === 'function') {
    window.newrelic.noticeError(error instanceof Error ? error : new Error(String(error)));
  }
}